import classNames from "classnames";
import type { PropsWithChildren } from "react";
import { forwardRef } from "react";
import { textStyles } from "../styles";
import type { PropsWithClassName, PropsWithDir, PropsWithOptionalClick } from "../types";

interface Props extends PropsWithClassName, PropsWithChildren, PropsWithOptionalClick, PropsWithDir {}
export const TextMain = forwardRef<HTMLParagraphElement, Props>(({ dir, children, className, onClick }, ref) => {
  return (
    <p
      ref={ref}
      dir={dir}
      onClick={onClick}
      className={classNames(textStyles.size100, textStyles.lsColor, textStyles.weight400, className)}
    >
      {children}
    </p>
  );
});

export const TextItalic = forwardRef<HTMLParagraphElement, Props>(({ children, className, onClick, dir }, ref) => {
  return (
    <TextMain ref={ref} dir={dir} className={classNames(textStyles.italic, className)} onClick={onClick}>
      {children}
    </TextMain>
  );
});

export const TextSemiAccent = forwardRef<HTMLParagraphElement, Props>(({ children, className, onClick, dir }, ref) => {
  return (
    <TextMain ref={ref} dir={dir} className={classNames(textStyles.weight500, className)} onClick={onClick}>
      {children}
    </TextMain>
  );
});

export const TextAccent = forwardRef<HTMLParagraphElement, Props>(({ children, className, onClick, dir }, ref) => {
  return (
    <TextMain ref={ref} dir={dir} className={classNames(textStyles.weight600, className)} onClick={onClick}>
      {children}
    </TextMain>
  );
});
